<script>
import AddressFieldset from "./AddressFieldset.vue";
import AddressForm from "./AddressForm.vue";

export default {
  data() {
    return Object.assign({
      showNewShippingAddress: false,
      shippingAddressId: null,
      billingAddressId: null,
      sameAddressForBilling: true
    }, window.__FORM__)
  },

  components: {
    AddressFieldset,
    AddressForm
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/CheckoutAddresses.vue